import { render, staticRenderFns } from "./allOrderList.vue?vue&type=template&id=f198e088&scoped=true&"
import script from "./allOrderList.vue?vue&type=script&lang=js&"
export * from "./allOrderList.vue?vue&type=script&lang=js&"
import style0 from "./allOrderList.vue?vue&type=style&index=0&id=f198e088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f198e088",
  null
  
)

export default component.exports